export type ValueWithLabel = {
  value: string | number;
  label?: string;
};

export type GroupedValues = Record<string, string[]>;
